/**
 * Validates if a given value is a valid currency amount.
 * Allowed formats: 0.00, 0.0, 0, -50, -0.10, -0.01
 * Disallowed formats: 0.000, abc, 0., £0.00
 * @param value - The value to be validated.
 * @returns `true` if the value is a valid currency amount, otherwise returns the error message "Invalid amount".
 */

export default (value: string | null) => {
  if (value === null || value === "") return true
  const regex = /^-?\d+(\.\d{1,2})?$/
  if (isNaN(Number(value)) || !regex.test(value)) {
    return "Invalid amount"
  }
  return true
}
